import { createFileRoute, redirect } from "@tanstack/react-router";
import { firstAllowedRoute } from "@/lib/auth";
import { OrdermailsAdmin } from "@/features/intake/OrdermailsAdmin";

// Beheer → Ordermails (docs/invoerbak.md §3b): admins only.
export const Route = createFileRoute("/_shell/order-mails")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin")) throw redirect({ to: firstAllowedRoute(context.session) });
  },
  component: () => (
    <div className="wl-page" data-screen-label="Back-office Ordermails">
      <OrdermailsAdmin />
    </div>
  ),
});
